/** --------------------- Interfaces----------------------------  */
// Logo Request Interface
export interface LogoRequest {
    requestId: string,
    requestName: string,
    requestType: string;
    submittedDate: string;
    convertedSubmittedDate: string;
    status: string;
    jobName: string;
    jobId: string,
    siteName: string,
    displayStatus: string
}

export type SortableKeys =
  | "requestName"
  | "requestType"
  | "convertedSubmittedDate"
  | "status"
  | "siteName";

/**----------------------- Constants -------------------------------- */

// Per page recods
const DATA_PER_PAGE = 100;

// LogoRequest table header list
export const LOGO_REQUEST_LIST_HEADERS: {
  label: string;
  sortKey: SortableKeys | null;
}[] = [
  { label: "Request #", sortKey: "requestName" },
  { label: "Request type", sortKey: "requestType" },
  { label: "Submitted Date", sortKey: "convertedSubmittedDate" },
  { label: "Status", sortKey: "status" },
  { label: "Job Name", sortKey: null },
  { label: "Job #", sortKey: null },
  { label: "Site Name", sortKey: null },
];

// Filter tabs to filter request data
  const FILTERTABS = [
    "All requests",
    "Draft",
    "Submitted",
    "Change Requested",
    "Approved",
    "Cancelled",
  ];

// Export all constants
export const LogoRequesListConstants = {
    DATA_PER_PAGE,
    LOGO_REQUEST_LIST_HEADERS,
    FILTERTABS
}
